const AUTH_CONSTANTS = {
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT',
    SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',
    SIGN_OUT_FAILURE: 'SIGN_OUT_FAILURE',
    OAUTH: 'OAUTH',
    ISAUTH: 'isAuth',
    USER_DETAILS: 'user-details',
    SUCCESSFULLY_SIGNED_IN: 'Successfully signed in!',
    SUCCESSFULLY_SIGNED_OUT: 'Successfully signed out!',
    SIGN_IN_AUTHENTICATION_FAILED: 'Sign in authentication failed!',
    SIGN_OUT_AUTHENTICATION_FAILED: 'Sign out authentication failed!',
    FAIL: 'fail',
    MULTI_SESSION_SIGN_OUT: 'MULTI_SESSION_SIGN_OUT',
    CHAT_END: 'CHAT_END'
}

export { AUTH_CONSTANTS }
